module.exports = __webpack_public_path__ + "static/media/tmb_imgInfoM2PC.ccd8c435.png";